<template>
  <div>
    <!--表格栏-->
    <el-table ref="refTable" :data="data.list" :highlight-current-row="highlightCurrentRow"
              @selection-change="selectionChange"
              @current-change="handleCurrentChange" v-loading="loading" :element-loading-text="$t('action.loading')"
              :border="border" :stripe="stripe" @row-click="rowClick"
              :show-overflow-tooltip="showOverflowTooltip" :max-height="maxHeight" :size="size" :align="align"
              style="width:100%;">
      <el-table-column v-if="showIndex" label="序号"
                       type="index"
                       width="50">
      </el-table-column>
      <el-table-column v-for="column in columns" header-align="center" :align="column.align?column.align:'center'"
                       :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth"
                       :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter"
                       v-if="column.vIf==null?true:column.vIf()"
                       :sortable="column.sortable==null?false:column.sortable"
                       :show-overflow-tooltip="column.showOverflowTooltip">
        <el-table-column :v-if="column.children!=null&&column.children>0" v-for="columnChild in column.children"
                         header-align="center"
                         align="center"
                         :prop="columnChild.prop" :label="columnChild.label" :width="columnChild.width"
                         :min-width="columnChild.minWidth"
                         :fixed="columnChild.fixed" :key="columnChild.prop" :type="columnChild.type"
                         :formatter="columnChild.formatter"
                         :sortable="columnChild.sortable==null?false:columnChild.sortable"
                         :show-overflow-tooltip="columnChild.showOverflowTooltip">
          <el-table-column :v-if="columnChild.children!=null&&columnChild.children>0"
                           v-for="columnChildThree in columnChild.children"
                           header-align="center"
                           align="center"
                           :prop="columnChildThree.prop" :label="columnChildThree.label" :width="columnChildThree.width"
                           :min-width="columnChildThree.minWidth"
                           :fixed="columnChildThree.fixed" :key="columnChildThree.prop" :type="columnChildThree.type"
                           :formatter="columnChildThree.formatter"
                           :sortable="columnChildThree.sortable==null?false:columnChildThree.sortable"
                           :show-overflow-tooltip="columnChildThree.showOverflowTooltip">
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <!--      操作列-->
      <el-table-column align="center" v-if="operation!=null"
                       :fixed="operation.fixed"
                       :label="operation.label"
                       :width="operation.width">
        <template slot-scope="scope">
          <el-button v-for="button in operation.buttons" :key="button.operation" :type="button.type"
                     v-if="button.vIf==null?true:button.vIf(scope.row)"
                     @click="operationButtonClick(button,scope.row)">
            {{ button.label }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:10px;">
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="refreshPageRequest"
                     @size-change="refreshPageSize"
                     :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize" :total="data.totalCount"
                     :page-sizes="sizes"
                     style="float:right;">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YlTable',
  components: {},
  props: {
    columns: Array, // 表格列配置
    operation: true,//操作列
    data: Object, // 表格分页数据
    size: { // 尺寸样式
      type: String,
      default: 'mini',
    },
    showIndex: {
      type: Boolean,
      default: false,
    },
    align: {  // 文本对齐方式
      type: String,
      default: 'left',
    },
    maxHeight: {  // 表格最大高度
      // type: Number,
      // default: 600
    },
    border: {  // 是否显示边框
      type: Boolean,
      default: false,
    },
    stripe: {  // 是否显示斑马线
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {  // // 是否高亮当前行
      type: Boolean,
      default: true,
    },
    showOverflowTooltip: {  // 是否单行显示
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // 分页信息
      pageRequest: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: false,  // 加载标识
      selections: [],  // 列表选中列
      sizes:[10,20,50,100]
    };
  },
  methods: {
    // 分页查询
    findPage: function() {
      this.loading = true;
      let callback = res => {
        this.loading = false;
      };
      this.$emit('findPage', {pageRequest: this.pageRequest, callback: callback});
    },
    doLayout(){
      if (this.$refs.refTable) {
        console.log("表格重新布局")
        this.$refs.refTable.doLayout();
      }
    },
    // 选择切换
    selectionChange: function(selections) {
      this.selections = selections;
      this.$emit('selectionChange', {selections: selections});
    },
    // 选择切换
    handleCurrentChange: function(val) {
      this.$emit('handleCurrentChange', {val: val});
    },
    // 换页刷新
    refreshPageRequest: function(pageNum) {
      this.pageRequest.pageNum = pageNum;
      this.findPage();
    },
    // 换每页条数刷新
    refreshPageSize(pageSize){
      this.pageRequest.pageSize = pageSize;
      this.findPage();
    },
    operationButtonClick: function(button, row) {//操作列的按钮点击事件
      this.$emit('operationButtonClick', button, row);
    },
    rowClick: function(row, event, column) {//行点击事件
      this.$emit('rowClick', row, event, column);
    },
  },
  mounted() {
    this.refreshPageRequest(1);
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Core/YlTable.vue